import React from 'react';
import {Helmet} from "react-helmet";
import classnames from "classnames";
import Layout from '../../components/Layout';
import queryString from 'query-string';
import IconArrow from '../../audi-ui-components/icons/Forward';
import IconCaution from '../../audi-ui-components/icons/Caution';
import IconSelect from '../../audi-ui-components/icons/Select';
import IconDownload from '../../audi-ui-components/icons/Download';
import Spinner from '../../audi-ui-components/Spinner';
import TextField from '../../audi-ui-components/TextField';
import Button from '../../audi-ui-components/Button';
import VINHelp from './VINHelp';
import {validateForm} from '../../functions/validation';
import {request} from '../../functions/apiRequestHelper';
import { gtmPageview, gtmPush } from '../../functions/gtm';
import { DEFAULT_THEME } from '../../constants';
import "./RecallForm.scss";
// import {
//     UI_AUDI
// } from '../../constants';

/*
TEST DATA:
WAUZZZ8T0AA078820 Not affected
WAUZZZ8T0AA078822 Future Blank
WAUZZZ8E58A051322 Active Outstanding
TRUZZZ8P3A1010087 Active Completed
WAUZZZ8P6DA023458 Image available
*/

class RecallForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            vinInput: "",
            vinInputError: null,
            loading: false,
            loaded: false,
            imgUrl: "",
            model: null, // from API
            vin: null, // from API
            recalls: null // from API
        }
    }

    componentDidMount() {
        gtmPageview(this.props.location.pathname);
    }

    handleCheck = () => {
        const {vinInput} = this.state;
        var err = validateForm({vin: vinInput});
        if (err && err.vin) {
            this.setState({vinInputError: err.vin});
        } else {
            // thneed.trigger(thneed.events.formSubmitSuccess, "takataRecall", {formData: vinInput, Action: "submit", formName: "takataRecall"}, true);
            gtmPush("form", "formSubmitSuccess", "takataRecall", {vin: vinInput});
            // submit to backend
            this.setState({loading: true});
            request(process.env.RAZZLE_API_HOST, {
                path: `1/recall/check?vin=${vinInput}`,
                method: "POST",
                body: JSON.stringify({vin: vinInput})
            }).then((response) => {
                // console.log(response);
                this.setState({loading: false, loaded: true, ...response});
                // console.log("get image");
                request(
                    `${process.env.RAZZLE_MEDIASERVICE}/MediaServiceCache?vin=${vinInput}&view=myaun1t&mimeType=image/png&wid=800`,
                    {}
                ).then((res) => {
                    // console.log(res);
                    this.setState({imgUrl: res.imageUrl});
                }).catch((error) => {
                  //
                });
            }).catch((error) => {
                console.error(error);
                this.setState({loading: false});
            });
        }
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const theme = query.theme || DEFAULT_THEME;
        const recall = this.state.recalls && this.state.recalls.length ? this.state.recalls[0] : {};
        const status = recall.recallStatus ? recall.recallStatus.status : 0;
        return (
            <Layout ui={query.ui} theme={theme}>
                <Helmet>
                    <title>Recall | Audi Australia</title>
                </Helmet>
                <main className="audi-forms__page recall">

                    {this.state.loading && <div className="spinner-wrapper"><Spinner isContinuous /></div>}

                    {!this.state.loading && !this.state.loaded && <div>
                        <div className="vin-search">
                            <div className="row">
                                <div className="col-12 col-xsmall">
                                    <TextField name="vin"
                                        label="Enter your Vehicle Identification Number (VIN)"
                                        value={this.state.vinInput}
                                        onChange={(v) => { this.setState({vinInput: v, vinInputError: null}); }}
                                        theme={theme === "dark" ? "light" : "light"}
                                        description={this.state.vinInputError}
                                    />
                                </div>
                                <div className="col-12 col-xsmall-auto">
                                    <Button label="Check" buttonType="primary" theme={theme === "dark" ? "light" : null} onClick={this.handleCheck} icon={<IconArrow small />} iconPosition="right" />
                                </div>
                            </div>
                        </div>
                        <VINHelp />
                    </div>}

                    {this.state.loaded && <div className="recall-results">
                        <h1 className="aui-headline-4 mb-5">{recall.title}</h1>
                        <div className="info" style={{backgroundImage: `url("${this.state.imgUrl}")`}}>
                            <p><b>VIN:</b> {this.state.vin}</p>
                            {this.state.model && <p><b>Model:</b> {this.state.model}</p>}
                            {recall.info && recall.info.map((data, i) => {
                                return (
                                    <p key={i}><b>{data.name}:</b> {data.value}</p>
                                );
                            })}
                        </div>
                        <div className={classnames("status mb-5", {"aui-color-red": status === 1 || status === 2, "aui-color-green": status === 3, "aui-color-gray85": status === 0, "aui-color-text-light": status > 0})}>
                            {recall.recallStatus && <p className="aui-headline-4">
                                {(status === 1 || status === 2) && <IconCaution large />}
                                {status === 3 && <IconSelect large />}
                                {recall.recallStatus.description}
                            </p>}
                        </div>
                        <div className="content mb-5">
                            {recall.recallStatus && <div dangerouslySetInnerHTML={{ __html: recall.recallStatus.content }} />}
                        </div>
                        {status === 3 && <div className="content mb-5">
                            It is important that you provide this confirmation to your local state registry so that any restrictions may be lifted from your vehicle.
                        </div>}
                        <div className="actions row mb-3">
                            <div className="col-auto">
                                <Button
                                    label="Download Search Result"
                                    icon={<IconDownload small />}
                                    buttonType="primary"
                                    theme={theme === "dark" ? "light" : null}
                                    href={recall.downloadResults}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => {
                                      // thneed.trigger(thneed.events.formSubmitSuccess, "takataRecall", {formData: "download", Action: "download", formName: "takataRecall"}, true);
                                      gtmPush("takataRecall", "download", "takataRecall");
                                    }}
                                />
                            </div>
                            <div className="col-auto">
                                <Button label="New Search" buttonType="secondary" theme={theme === "dark" ? "light" : null} onClick={() => {window.location.reload();}} />
                            </div>
                        </div>
                    </div>}

                </main>
            </Layout>
        );
    }
}

export default RecallForm;
